if (!customElements.get('iband-bundle')) {
  customElements.define('iband-bundle', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.strings = JSON.parse(this.querySelector('[data-strings]').textContent);
      this.dialog = this.querySelector('dialog');
      this.slots = this.querySelector('[data-slots]');
      this.editor = this.querySelector('[data-editor]');
      this.grid = this.querySelector('[data-grid]');
      this.total = this.querySelector('[data-total]');
      this.error = this.querySelector('[data-error]');
      this.add = this.querySelector('[data-add]');
      this.search = this.querySelector('[data-search]');
      this.instruction = this.querySelector('[data-instruction]');
      this.selected = [null, null, null];
      this.active = 1;
      this.products = [];
      this.cache = new Map();
      this.base = window.Shopify?.routes?.root || '/';
      this.money = amount => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:this.dataset.currency || 'USD'}).format(amount / 100);
      this.querySelector('[data-open]').addEventListener('click', async () => {
        this.dialog.showModal();
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        if (!this.products.length) await this.load();
        else await this.syncCurrent();
      });
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => { document.body.style.overflow = this.previousOverflow || ''; });
      this.search.addEventListener('input', () => this.renderGrid());
      this.add.addEventListener('click', () => this.addSet());
    }
    esc(value) { return String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }
    image(product, variant) { return variant?.featured_image?.src || product.featured_image || product.images?.[0] || ''; }
    async details(handle) {
      if (!this.cache.has(handle)) {
        const promise = fetch(this.base + 'products/' + encodeURIComponent(handle) + '.js').then(r => {if (!r.ok) throw Error(this.strings.load_failed); return r.json();});
        this.cache.set(handle, promise);
        promise.catch(() => this.cache.delete(handle));
      }
      return this.cache.get(handle);
    }
    async syncCurrent() {
      const current = await this.details(this.dataset.productHandle);
      const id = document.getElementById('product-form-' + this.dataset.section)?.querySelector('[name="id"]')?.value || this.dataset.currentVariant;
      const variant = current.variants.find(v => String(v.id) === String(id) && v.available) || current.variants.find(v => v.available);
      if (variant && (!this.selected[0] || this.selected[0].product.handle === current.handle)) this.selected[0] = {product:current, variant};
      this.render();
    }
    async load() {
      if (this.loading) return;
      this.loading = true;
      this.error.hidden = true;
      try {
        let page = 1, batch;
        const products = [];
        do {
          const response = await fetch(this.base + 'collections/' + encodeURIComponent(this.dataset.collection) + '/products.json?limit=250&page=' + page++);
          if (!response.ok) throw Error(this.strings.load_failed);
          batch = (await response.json()).products || [];
          products.push(...batch.filter(p => p.variants.some(v => v.available)));
        } while (batch.length === 250);
        if (!products.some(p => p.handle === this.dataset.productHandle)) throw Error(this.strings.load_failed);
        this.products = products;
        await this.syncCurrent();
      } catch(e) {this.showError(e.message); this.total.textContent = this.strings.load_failed;}
      finally {this.loading = false;}
    }
    showError(message) {this.error.textContent = message; this.error.hidden = false;}
    render() {
      const s = this.strings;
      const ready = this.selected.every(Boolean);
      const prices = this.selected.filter(Boolean).map(item => item.variant.price);
      const freeIndex = ready ? this.selected.findIndex(item => item.variant.price === Math.min(...prices)) : -1;
      this.slots.innerHTML = '';
      this.editor.innerHTML = '';
      this.editor.hidden = !this.selected[this.active];
      this.selected.forEach((item,index) => {
        const card = document.createElement('button');
        card.type = 'button';
        card.className = 'ibundle__slot';
        card.dataset.active = String(index === this.active);
        const label = s.band + ' ' + (index + 1);
        card.setAttribute('aria-pressed', String(index === this.active));
        card.setAttribute('aria-label', label + ' · ' + (item ? s.change : s.choose));
        card.innerHTML = '<span class="ibundle__slot-tab">' + this.esc(label) + ' · ' + this.esc(item ? s.change : s.choose) + '</span>';
        card.addEventListener('click', () => {
          if (this.selecting || this.busy) return;
          this.active = index; this.search.value = ''; this.render();
          this.grid.scrollTop = 0;
          this.querySelector('.ibundle__workspace').scrollTop = 0;
        });
        if (item) {
          const p = item.product, v = item.variant;
          card.insertAdjacentHTML('beforeend', '<img class="ibundle__selected-image" src="' + this.esc(this.image(p,v)) + '" alt="' + this.esc(p.title + ' - ' + v.title) + '"><div class="ibundle__slot-name">' + this.esc(p.title) + '</div><div class="ibundle__price">' + (index === freeIndex ? '<s>' + this.money(v.price) + '</s> <strong>' + this.esc(s.free) + '</strong>' : this.money(v.price)) + '</div>');
          if (index === this.active) {
          this.editor.innerHTML = '<p class="ibundle__editor-title">' + this.esc(label + ' · ' + p.title) + '</p>';
          p.options.forEach((option, optionIndex) => {
            if (option.name === 'Title' && option.values[0] === 'Default Title') return;
            const group = document.createElement('div');
            group.className = 'ibundle__option';
            group.innerHTML = '<label>' + this.esc(option.name) + '<select aria-label="' + this.esc(label + ' ' + option.name) + '">' + option.values.map(value => '<option value="' + this.esc(value) + '"' + (value === v.options[optionIndex] ? ' selected' : '') + (p.variants.some(candidate => candidate.available && candidate.options[optionIndex] === value) ? '' : ' disabled') + '>' + this.esc(value) + '</option>').join('') + '</select></label>';
            group.querySelector('select').addEventListener('change', event => this.selectOption(index,optionIndex,event.target.value));
            if (/colou?r/i.test(option.name)) {
              const colors = document.createElement('div');
              colors.className = 'ibundle__colors';
              option.values.forEach(value => {
                const candidates = p.variants.filter(candidate => candidate.options[optionIndex] === value);
                const available = candidates.some(candidate => candidate.available);
                const imageVariant = candidates.find(candidate => candidate.featured_image) || candidates[0];
                const button = document.createElement('button');
                button.type = 'button'; button.disabled = !available;
                button.title = value;
                button.setAttribute('aria-label', label + ' ' + value);
                button.setAttribute('aria-pressed', String(value === v.options[optionIndex]));
                button.innerHTML = '<img loading="lazy" src="' + this.esc(this.image(p,imageVariant)) + '" alt="">';
                button.addEventListener('click', () => this.selectOption(index,optionIndex,value));
                colors.appendChild(button);
              });
              group.appendChild(colors);
            }
            this.editor.appendChild(group);
          });
          }
        } else card.insertAdjacentHTML('beforeend','<div class="ibundle__empty">' + this.esc(s.empty) + '</div>');
        this.slots.appendChild(card);
      });
      this.add.disabled = !ready || this.busy;
      this.total.textContent = ready ? s.total + ' ' + this.money(prices.reduce((a,b) => a+b,0) - Math.min(...prices)) + ' · ' + s.save + ' ' + this.money(Math.min(...prices)) : s.empty;
      this.instruction.textContent = s.choose + ' · ' + s.band + ' ' + (this.active + 1);
      this.renderGrid();
    }
    selectOption(index, optionIndex, value) {
      const item = this.selected[index];
      const wanted = [...item.variant.options]; wanted[optionIndex] = value;
      const candidates = item.product.variants.filter(v => v.available && v.options[optionIndex] === value);
      const variant = candidates.find(v => v.options.every((val,i) => val === wanted[i])) || candidates[0];
      if (variant) {item.variant = variant; this.render();}
    }
    renderGrid() {
      this.grid.innerHTML = '';
      const query = this.search.value.trim().toLowerCase();
      const products = this.products.filter(p => p.title.toLowerCase().includes(query));
      products.forEach(product => {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'ibundle__product';
        button.setAttribute('aria-label', product.title);
        button.setAttribute('aria-pressed', String(this.selected[this.active]?.product.handle === product.handle));
        button.innerHTML = '<img loading="lazy" src="' + this.esc(product.images?.[0]?.src || '') + '" alt=""><span>' + this.esc(product.title) + '</span>';
        button.addEventListener('click', async () => {
          if (this.selecting || this.busy) return;
          this.selecting = true;
          const index = this.active;
          button.disabled = true;
          this.error.hidden = true;
          try {
            const p = await this.details(product.handle);
            const variant = p.variants.find(v => v.available);
            if (!variant) throw Error(this.strings.load_failed);
            this.selected[index] = {product:p, variant};
            this.render();
          } catch(e) {this.showError(e.message); button.disabled = false;}
          finally {this.selecting = false;}
        });
        this.grid.appendChild(button);
      });
      if (!products.length) this.grid.textContent = this.strings.none;
    }
    async addSet() {
      if (this.busy || !this.selected.every(Boolean)) return;
      this.busy = true; this.add.disabled = true; this.add.textContent = this.strings.adding; this.error.hidden = true;
      try {
        const response = await fetch(this.base + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items:this.selected.map(item => ({id:item.variant.id,quantity:1}))})});
        if (!response.ok) throw Error(this.strings.failed);
        window.location.assign(this.base + 'cart');
      } catch(e) {this.showError(e.message || this.strings.failed); this.busy=false; this.add.disabled=false; this.add.textContent=this.strings.add;}
    }
  });
}
